import { baseColors } from "@Constants/baseStyles"
import { StyleSheet } from "react-native"

const styles = StyleSheet.create({
    container: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        marginVertical: 8,
        height: 100
    },
    title: {
        textAlign: "center"
    },
    cardContainer: {
        backgroundColor: baseColors.green.primary,
        paddingVertical: 30,
        borderRadius: 10
    }
})

export default styles
